
export default {
    INTEREST_FORM: `/api/online-postgrad-programme-submissions`,
    VIDEO_GENERATE: '/api/v1/video-conversions',
}